async function getWindowsAPI(atiID, qs = '') {
  return await window
    .fetch(`/webapi/timeslots/api/v1/timeslots/${atiID}${qs}`, { method: 'GET' })
    .catch((error) => console.log('error', error));
}

export default getWindowsAPI;
